import { FilterBar } from '@/components/filters/FilterBar';
import { SearchInput } from '@/components/filters/SearchInput';
import { Select } from '@/components/ui/Select';
import { useAdminLogs } from '@/hooks/useAdminMonitoring';
import { useState } from 'react';
import { LogsTable } from '../components/LogsTable';

export function LogsExplorerPage() {
  const [search, setSearch] = useState('');
  const [level, setLevel] = useState('');
  const { data, isLoading } = useAdminLogs({ search, level: level || undefined, limit: 100 });
  const logs = data?.data || [];

  return (
    <div className="space-y-6">
      <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Explorateur de logs</h1><p className="text-sm text-neutral-500">{data?.pagination?.totalItems ?? 0} entrées</p></div>
      <FilterBar>
        <div className="w-72"><SearchInput value={search} onChange={setSearch} placeholder="Rechercher dans les logs..." /></div>
        <div className="w-40">
          <Select
            value={level}
            onChange={(e) => setLevel(e.target.value)}
            placeholder="Niveau"
            options={[
              { value: '', label: 'Tous' },
              { value: 'error', label: 'Error' },
              { value: 'warn', label: 'Warn' },
              { value: 'info', label: 'Info' },
              { value: 'debug', label: 'Debug' },
            ]}
          />
        </div>
      </FilterBar>
      <LogsTable data={logs} loading={isLoading} />
    </div>
  );
}
